var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[('live' !== _vm.$authed().appMode)?_c('div',{staticClass:"alert alert--warning"},[_c('div',[_c('div',[_c('p',[_vm._v("Running in "+_vm._s(_vm.$authed().appMode)+" mode.")])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }